import axios from "axios";
import CryptoJS from 'crypto-js';



export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    // Check if the decrypted data is valid JSON
    if (!decryptedData) {
      throw new Error("Decryption failed. Data may be corrupted or tampered with.");
    }

    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Error during decryption:", error.message);
    // Handle the error (e.g., return null, throw an error, etc.)
    return null; // or you could throw an error or return a specific error message
  }
};



const instance = axios.create({
  // baseURL: 'https://vbk0n794-8080.inc1.devtunnels.ms/',
  //  baseURL: 'http://localhost:8080/', 
  // baseURL: 'https://lb.impulz-lms-backend.net/', 
  // baseURL: 'http://ec2-3-111-200-106.ap-south-1.compute.amazonaws.com:8080/', 
  // baseURL:'https://newtonimpulzserver.df.r.appspot.com/',
  baseURL: process.env.REACT_APP_API_BASE_URL, 
  headers: {
    "Content-type": "application/json",
    'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
    "ngrok-skip-browser-warning": "69420",
  }
});

export default instance;

export const logout = () => {
  localStorage.removeItem("loggedInUserId");
  localStorage.removeItem("usertype");
  localStorage.removeItem("studentteacherid");
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('username');
  localStorage.removeItem('activeSettingTab');
  localStorage.removeItem('calendarTab');
  localStorage.removeItem('activeTab');


  document.title = "LMS-impluz";
};


export function removeBracketedText(input) {
  return input.replace(/\s*\(.*?\)\s*/g, '');
}

// export  const loginUrl = 'cb589ea3-9b05-44f8-b7c2-de71d128cb0b';


const SECRET_KEY = 'qwertyuiop'; // Replace with your own secret key

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};




export const formatType = (type) => {
  return type
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const renderDoc = (url) => {
  if (url.endsWith(".doc") || url.endsWith(".docx")) {
    window.open(`https://docs.google.com/viewer?url=${url}&embedded=true`, "_blank");
  } else {
    window.open(url, "_blank");
  }
};
